import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionFees } from 'types/Merchant';

type Plan = Partial<SubscriptionFees>;

const initialState: Plan = {};

const subscriptionPlanSlice = createSlice({
  name: 'subscriptionPlan',
  initialState,
  reducers: {
    updateSubscriptionPlan(state, action: PayloadAction<Plan>) {
      return (state = action.payload);
    }
  }
});

const { actions, reducer } = subscriptionPlanSlice;
export const { updateSubscriptionPlan } = actions;
export default reducer;
